import pluralize from 'pluralize';

export const buildingTypes = [
  {
    id: 'condo',
    name: 'Condo/Coop',
  },
  {
    id: 'rental',
    name: 'Rental',
  },
];

export const accessControls = [
  {
    id: 'brivo',
    name: 'Brivo',
  },
];

export const cameraSystems = [
  {
    id: 'eagle_eye',
    name: 'Eagle Eye',
  },
  {
    id: 'bmx',
    name: 'BMX',
  },
];

export const paymentSystems = [
  {
    id: 'clickpay',
    name: 'Clickpay',
  },
  {
    id: 'aptexx',
    name: 'Aptexx',
  },
];

export const ssoProviders = [
  {
    id: 'carson',
    name: 'Carson',
  },
  {
    id: 'building_link',
    name: 'Building Link',
  },
];

export const SERVICE_REQUEST_STATUSES = [
  {
    id: 'opened',
    name: 'Open',
  },
  {
    id: 'in_progress',
    name: 'In Progress',
  },
  {
    id: 'resolved',
    name: 'Resolved',
  },
  {
    id: 'cancelled',
    name: 'Cancelled',
  },
];

export const serviceRequestPendingResolved = [
  {
    id: 'pending',
    name: 'Pending',
  },
  {
    id: 'resolved',
    name: 'Resolved',
  },
];

export const limitOptions = [
  {
    id: 25,
    name: '25 / page',
  },
  {
    id: 50,
    name: '50 / page',
  },
  {
    id: 100,
    name: '100 / page',
  },
  {
    id: 200,
    name: '200 / page',
  },
];

export const visitorStatusFilterOptions = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'expired',
    label: 'Expired',
  },
];

export const ACCESS_CARDS_TYPE_OPTIONS = [
  {
    value: 'two_n',
    label: '2N',
  },
  {
    value: 'lyazon',
    label: 'Lyazon',
  },
];

export const VIEW_OPTIONS = [
  {
    value: 'list',
    label: 'List View',
  },
  {
    value: 'calendar',
    label: 'Calendar View',
  },
];

export const visitorRoleFilterOptions = [
  {
    value: '6',
    label: 'Visitor',
  },
  {
    value: '9',
    label: 'Broker',
  },
  {
    value: '10',
    label: 'Prospective tenant',
  },
];

export const paginationOptions = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];

export const DATE_RANGES_TYPES = {
  created: 'created',
  created_at: 'created_at',
  created_date: 'created_date',
  updated_at: 'updated_at',
  latest_call_time: 'latest_call_time',
  valid_until: 'valid_until',
  last_activity_time: 'last_activity_time',
  effective_date: 'effective_date',
  date: 'date',
  starts: 'starts',
};

export const TABLE_DATA_TYPES = {
  accessPoints: (count) => `access ${pluralize('point', count)}`,
  carsonActivity: (count) => `action ${pluralize('record', count)}`,
  personActionsLog: (count) => `person action ${pluralize('record', count)}`,
  buildings: (count) => pluralize('building', count),
  doorsOpeningLog: (count) => `door opening log ${pluralize('record', count)}`,
  deliveries: (count) => pluralize('delivery', count),
  items: (count) => pluralize('item', count),
  posts: (count) => pluralize('post', count),
  comments: (count) => pluralize('comment', count),
  pendingApprovalComments: (count) =>
    `pending approval ${pluralize('comment', count)}`,
  person: (count) => pluralize('person', count),
  serviceRequests: (count) => `service ${pluralize('request', count)}`,
  visitors: (count) => `person ${pluralize('record', count)}`,
  visitorsLog: (count) => `entry ${pluralize('record', count)}`,
  ip: (count) => pluralize('ip', count),
  pmcs: (count) => pluralize('pmc', count),
  doors: (count) => pluralize('door', count),
  cameras: (count) => pluralize('camera', count),
  units: (count) => pluralize('unit', count),
  types: (count) => pluralize('type', count),
  accessCards: (count) => `access ${pluralize('card', count)}`,
  accessCardBatches: (count) => `access card ${pluralize('batch', count)}`,
  callRecords: (count) => `call ${pluralize('record', count)}`,
  events: (count) => pluralize('event', count),
};

export const timeOnlyFormat = 'hh:mm:ss';
export const dateOnlyFormat = 'MM/DD/YY';
export const defaultDateFormat = 'MM/DD/YY hh:mm a';
export const fullTimeDateFormat = 'MM/DD/YY hh:mm:ss';
export const fullTimeDateFormat24 = 'MM/DD/YY HH:mm:ss';
export const notificationDateFormat = 'MM/DD/YY [at] h:mm A'; // looks better with hh:mm

export const drawerClosedWidth = 75;
export const drawerOpenedWidth = 272;

export const LOADABLE_DELAY = 600;
export const LOADABLE_TIME_OUT = 10000;
export const INACTIVITY_LOG_OUT_TIME = 7200000;
export const INACTIVITY_COUNT_DOWN_TIME = 30000;
export const IMPORT_LIMIT = 3;
export const IMPORT_DELAY = 1000;

export const BMX_LOGGER = true;
